import { render, staticRenderFns } from "./CoberturaEstoqueManual.vue?vue&type=template&id=156262d6&scoped=true"
import script from "./CoberturaEstoqueManual.vue?vue&type=script&lang=js"
export * from "./CoberturaEstoqueManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156262d6",
  null
  
)

export default component.exports